// import screen2 from '../../../images/screen1-0';
import screen2 from '../../../images/mockups/012-portrait.png';


function FirstContentC() {
  return (
    <div className="flex flex-col items-center w-screen overflow-hidden">
      <div className="flex flex-row justify-between pb-60 m10:flex-col items-center max-w-7xl w-full px-10 m6:px-5" id="FirstContentC-wrapper">
        <div className="w-3/5 m10:w-full">
          <div className="text-6xl m6:text-4xl m10:text-center m6:font-bold" id='first-compC-slogan'>
            Maintenance curative
          </div>
          <div className="pt-5 text-2xl m10:text-center" id='first-compC-description'>
            Avec notre méthode curative, gagnez un gain considérable en temps & en productivité lors de votre prochaine manœuvre d'une machine défectueuse ou cassée.
          </div>
        </div>
        <div className="flex items-center justify-center m10:pt-20 " id='first-compC-right-side'>
          <img src={screen2} className="w-96" id='first-compC-screen' alt='screen2' />
        </div>
      </div>
    </div>
  );
}

export default FirstContentC;